import "@vidstack/react/player/styles/base.css";

import { AnimatePresence, motion } from "framer-motion";
import { FaPause, FaPlay } from "react-icons/fa";

import { Icons } from "../icons/icons";
import { cn } from "@/lib/utils";
import { useDataContext } from "@/app/_context";

export default function BigPlayButton({
  portal,
  virginState,
}: {
  portal: boolean;
  virginState?: boolean;
}) {
  const { isPaused, videoCanplay, playerInstance } = useDataContext();
  // Show spinner when portal player hasn't signalled can-play yet
  const isLoading = portal && !virginState && !videoCanplay;

  return (
    <AnimatePresence>
      {(isPaused || virginState || isLoading) && (
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => !isLoading && playerInstance?.play().catch(() => {})}
          className={cn(
            !portal && "md:mb-1",
            !virginState && "bg-zinc-800/40",
            "absolute inset-0 group rounded-md text-white items-center flex justify-center z-10"
          )}
        >
          <span className="rounded-full p-6 bg-black/20 flex place-items-center">
            {isLoading ? (
              <Icons.spinner className="w-12 h-12 animate-spin text-white/80" />
            ) : isPaused ? (
              <span className="relative left-1"><FaPlay size={50} /></span>
            ) : (
              <span className="relative left-1"><FaPause size={50} /></span>
            )}
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
